import { render } from "./CardTemplate.vue?vue&type=template&id=674aacea&scoped=true"
import script from "./CardTemplate.vue?vue&type=script&lang=js"
export * from "./CardTemplate.vue?vue&type=script&lang=js"

import "./CardTemplate.vue?vue&type=style&index=0&id=674aacea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-674aacea"]])

export default __exports__